<template>
  <a href="#" v-on:click="switchTab" v-bind:class="{ 'border-b-2 border-indigo-600 text-indigo-600 fill-indigo-600 hover:border-indigo-700 hover:text-indigo-700 hover:fill-indigo-700': isActive, 'text-gray-500 hover:border-gray-700 hover:text-gray-700 hover:fill-gray-700': !isActive }" class=" font-normal flex-grow block pb-5 pt-6 mr-7 ml-7 relative hover:border-b-2 duration-300 transition-colors">
    <slot></slot>
    <Counter class="absolute top-4 right-0" v-if="shouldShowCounter" v-bind:count="counterValue" inline="true" />
  </a>
</template>


<script>
import Counter from '../../page/CounterWidget.vue'

export default {
  name: 'CategoryTab',
  props: ['counterValue', 'tabLabel', 'currentTabLabel', 'tabText', 'icon'],
  components: {
    Counter,
  },
  computed: {
    shouldShowCounter() {
      return this.counterValue > 0;
    },
    isActive() {
      return this.tabLabel === this.currentTabLabel;
    }
  },
  methods: {
    switchTab() {
      this.$emit('switch-tab-event', this.tabLabel);
    },
  },
  data() {
    return {
    }
  },
}
</script>
